<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="association-settings-audit-logs-title">
                {{ $t('association.audit_logs.title') }}
            </div>
        </div>
        <audit-log-table :is_association_section="true" :association_id="association_id" ref="AuditLogsTable" />
    </div>
</template>

<script>
import AuditLogTable from '@/components/tables/AuditLogs.vue';

export default {
    components: {
        AuditLogTable,
    },
    props: {
        association_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        reload() {
            this.$refs.AuditLogsTable.reload();
        },
    },
};
</script>
